import { apiClient } from '@/services/ApiClient.js'

export default {
  getSuppliers(query) {
    return apiClient
      .get('suppliers', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSupplier(payload) {
    return apiClient
      .get('suppliers/' + payload.supplierId, {
        params: payload.query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createSupplier(supplier) {
    return apiClient
      .post('suppliers', supplier)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editSupplier(id, supplier) {
    return apiClient
      .patch('suppliers/' + id, supplier)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSupplierByRetailerVkn(retailerVkn) {
    return apiClient
      .get('suppliers/by-tin/' + retailerVkn)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editSupplierType(id, supplierType) {
    return apiClient
      .patch('suppliers/' + id + '/update-types', { types: supplierType })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
